export default __webpack_public_path__ + "static/media/icon-visualizar.aac6c596.svg";